// extracted by mini-css-extract-plugin
export var dropdownButton = "_3f-0";
export var fullWidthDropdownButton = "_3f-1";
export var icon = "_3f-3";
export var iconPlaceholder = "_3f-2";
export var menuItemRow = "_3f-5";
export var shortcutContainer = "_3f-4";